import { render } from "./PreorderInfo.vue?vue&type=template&id=32e174fa&scoped=true&ts=true"
import script from "./PreorderInfo.vue?vue&type=script&lang=ts"
export * from "./PreorderInfo.vue?vue&type=script&lang=ts"

import "./PreorderInfo.vue?vue&type=style&index=0&id=32e174fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e174fa"]])

export default __exports__